// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CallAvailability: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 18">
            <path
                fill="currentColor"
                d="m5.936.8 1.16 2.01a.4.4 0 0 1-.692.4l-.957-1.657-.218.142a8.631 8.631 0 0 0-2.447 2.523l1.658.956a.4.4 0 0 1-.4.692L2.384 4.91a8.704 8.704 0 0 0-.975 3.63H3.33a.4.4 0 1 1 0 .8H1.409a8.704 8.704 0 0 0 .975 3.63l1.656-.956a.4.4 0 1 1 .4.692l-1.657.956a8.68 8.68 0 0 0 2.447 2.513l.217.141.957-1.656a.4.4 0 0 1 .472-.18l.074.034a.4.4 0 0 1 .146.546l-1.16 2.01a.4.4 0 0 1-.544.147 9.475 9.475 0 0 1-3.508-3.497A9.516 9.516 0 0 1 .601 8.94c0-1.699.446-3.332 1.282-4.778A9.429 9.429 0 0 1 5.392.653.4.4 0 0 1 5.936.8Zm4.234 6.975a1.16 1.16 0 1 1-.197 2.303L7.96 13.56a.4.4 0 1 1-.692-.399l2.01-3.483a1.16 1.16 0 0 1 .89-1.903Z"
            />
        </svg>
    );
};

export default React.memo(CallAvailability);
